'use client';

import React from 'react';
import DynamicForm, { ApiAttributeType } from '../DynamicForm/DynamicForm';
import { ApiAttribute } from '@context/openapi/types';

const sectionLabel: Record<ApiAttributeType, string> = {
  [ApiAttributeType.PATH]: 'Path Parameters',
  [ApiAttributeType.QUERY]: 'Query Parameters',
  [ApiAttributeType.BODY]: 'Body',
};

export interface ParamterSectionProps {
  params: ApiAttribute[];
  type: ApiAttributeType;
  updateParams: (params: ApiAttribute[], type: ApiAttributeType) => void;
  isEmptyAttributesVisible: boolean;
  actions?: React.ReactNode;
}

export const ParamterSection: React.FC<ParamterSectionProps> = ({
  params,
  type,
  updateParams,
  isEmptyAttributesVisible,
  actions,
}) => {
  if (params.length === 0) {
    return null;
  }
  return (
    <div>
      <div className="flex justify-between items-center mb-2">
        <span className="text-[11px] font-medium text-gray-500 bg-gray-100 rounded px-1.5 py-0.5 inline-block">
          {sectionLabel[type]}
        </span>
        {actions}
      </div>
      <DynamicForm
        options={{
          params: params,
          type: type,
          isEmptyAttributesVisible: isEmptyAttributesVisible,
        }}
        updateParams={updateParams}
      />
    </div>
  );
};
